import React, { FC } from 'react';

import { Box, HStack } from '@chakra-ui/react';

import { severityOptionsWithAll } from 'components/DataDisplay/Utils/renderSeverity';
import { cloudProviderOptionsWithAll, Select } from 'components/index';
import {
  overDueFilterOptions,
  ticketStatusOptions,
} from 'containers/Findings/Tickets/Components/utils';
import { TicketsSearchParamsProps } from 'containers/Findings/Tickets/types';
import { useSearchParams } from 'hooks/useSearchParams';

interface TicketFiltersProps {
  severity: Record<string, any>;
  status: Record<string, any>;
  resourceType: Record<string, any>;
  provider: Record<string, any>;
  assignee: Record<string, any>;
  resourceTypeOptions: Record<string, any>[];
  assigneeOptions: Record<string, any>[];
  isOverDueDate: boolean;
  updateValue: (field: string, value: string) => void;
  isDisabled: boolean;
  isLoadingAssignees: boolean;
}

export const TicketFilters: FC<TicketFiltersProps> = props => {
  const {
    severity,
    status,
    resourceTypeOptions,
    resourceType,
    provider,
    isOverDueDate,
    updateValue,
    isDisabled,
    assigneeOptions,
    assignee,
    isLoadingAssignees,
  } = props;
  const params = useSearchParams<TicketsSearchParamsProps>();

  return (
    <HStack>
      <Box>
        <Select
          options={ticketStatusOptions}
          value={status}
          onChange={s => updateValue('status', s)}
          showIconInValueContainer
          menuPortalTarget={document.body}
          isAFilter
          leftMessage="State"
          isDisabled={isDisabled}
          showUndefinedValueLabel={false}
        />
      </Box>
      <Box>
        <Select
          options={severityOptionsWithAll}
          value={severity}
          onChange={s => updateValue('severity', s)}
          showIconInValueContainer
          menuPortalTarget={document.body}
          isAFilter
          isDisabled={isDisabled}
          leftMessage="Severity"
          showUndefinedValueLabel={false}
        />
      </Box>
      {params?.viewBy !== 'findings' && (
        <>
          <Box>
            <Select
              options={overDueFilterOptions}
              value={isOverDueDate}
              onChange={s => updateValue('isOverDueDate', s)}
              showIconInValueContainer
              menuPortalTarget={document.body}
              isAFilter
              isDisabled={isDisabled}
              showClearIndicator={false}
              leftMessage="Is over due date"
              showUndefinedValueLabel={false}
            />
          </Box>
          <Box>
            <Select
              options={resourceTypeOptions}
              value={resourceType}
              onChange={s => updateValue('resourceType', s)}
              showIconInValueContainer
              menuPortalTarget={document.body}
              isAFilter
              isDisabled={isDisabled}
              leftMessage="Resource type"
              showUndefinedValueLabel={false}
            />
          </Box>
          <Box>
            <Select
              options={cloudProviderOptionsWithAll}
              value={provider}
              onChange={s => updateValue('provider', s)}
              showIconInValueContainer
              menuPortalTarget={document.body}
              isAFilter
              isDisabled={isDisabled}
              leftMessage="Cloud"
              showUndefinedValueLabel={false}
            />
          </Box>
        </>
      )}
      <Box>
        <Select
          options={assigneeOptions}
          value={assignee}
          onChange={s => updateValue('assignee', s)}
          showIconInValueContainer
          menuPortalTarget={document.body}
          isAFilter
          isDisabled={isDisabled}
          leftMessage="Owner"
          isLoading={isLoadingAssignees}
          showUndefinedValueLabel={false}
        />
      </Box>
    </HStack>
  );
};
